'use strict';

/**
 * @ngdoc service
 * @name sharedModule.Maintenance
 * @description
 * # Maintenance
 * Service in the sharedModule.
 */

(function (angular, window, undefined) {
  var MaintenanceService = function (ApiService, $window) {
    'ngInject'
    var self = this;

    self.data = {
      message: ""
    };

    self.GetMaintenanceMessage = ApiService.endpoint.get({
      url: 'api/maintenance/GetMaintenanceMessage',
      memoization: false,
      success: function (data) {
        self.data.message = data !== undefined && data !== null ? data : '';
      }
    });

  };

  angular.module('sharedModule')
    .service('MaintenanceService', MaintenanceService);
})(angular, window);
